import {
  ContactSection,
  ServiceDescriptionSection,
  TopSection,
} from "../../components";
import ServicesTable from "../../components/ServicesTable/ServicesTable";
import SEOHead from "../../components/SEO/SEOHead";
import styleVariables from "../../variables.module.scss";
import { SERVICES_DATA } from "../../data/servicesData";
import {
  generateOrganizationSchema,
  generateWebPageSchema,
  generateBreadcrumbSchema,
} from "../../utils/structuredData";

const ServicesPage = () => {
  const organizationSchema = generateOrganizationSchema();
  const webPageSchema = generateWebPageSchema(
    "Our Services - Brin's Handyman Services Ottawa",
    "Professional handyman services in Ottawa including home repairs, painting, plumbing, carpentry, drywall installation, and furniture repairs. For specialized work requiring licensed professionals, we collaborate with certified contractors. Quality work guaranteed.",
    "https://brinshandymanservices.ca/services"
  );
  const breadcrumbSchema = generateBreadcrumbSchema([
    { name: "Home", url: "https://brinshandymanservices.ca" },
    { name: "Services", url: "https://brinshandymanservices.ca/services" },
  ]);

  return (
    <div>
      <SEOHead
        title="Our Services - Brin's Handyman Services Ottawa"
        description="Professional handyman services in Ottawa including home repairs, painting, plumbing, carpentry, drywall installation, and furniture repairs. For specialized work requiring licensed professionals, we collaborate with certified contractors. Quality work guaranteed."
        canonical="/services"
        structuredData={[organizationSchema, webPageSchema, breadcrumbSchema]}
      />
      <TopSection
        subTitle="JUST A PHONE CALL AWAY"
        mainTitle="Our Services"
        content="No matter where you are in the bustling city of Ottawa or its peaceful suburbs, Brin's Handyman Services is here to serve you. From downtown Ottawa to the outskirts, our exceptional services are just a phone call away."
      />
      {Object.values(SERVICES_DATA).map((serviceData, index) => {
        const direction = index % 2 ? "left" : "right";
        const textColor = index % 2 ? "black" : "white";
        const titleColor =
          index % 2 ? "black" : styleVariables.themeOrangeColor;
        const backgroundColor =
          index % 2
            ? styleVariables.themeOrangeColor
            : styleVariables.themeGreyColor;
        return (
          <ServiceDescriptionSection
            key={serviceData.slug}
            backgroundColor={backgroundColor}
            backgroundImageUrl={serviceData.mainImageUrl}
            textColor={textColor}
            titleColor={titleColor}
            direction={direction}
            title={serviceData.name}
            description={serviceData.description}
          />
        );
      })}
      <ServicesTable />
      <ContactSection />
    </div>
  );
};

export default ServicesPage;
